import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppIcBefehl29 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Form",
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".grey{fill:#646973;}.green{fill:#78be14;}.red{fill:#ec0016;}.black{fill:currentColor;}" }) }), /* @__PURE__ */ _jsxs("g", {
		id: "Command_29",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "Signal",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "black",
					d: "M38,52.83h-12c-1.1,0-2-.9-2-2v-20c0-.53.21-1.04.59-1.41l2.83-2.83c.38-.38.88-.59,1.41-.59h6.34c.53,0,1.04.21,1.41.59l2.83,2.83c.38.38.59.88.59,1.41v20c0,1.1-.9,2-2,2Z"
				}),
				/* @__PURE__ */ _jsx("circle", {
					className: "grey",
					cx: 32,
					cy: 35.83,
					r: 2
				}),
				/* @__PURE__ */ _jsx("circle", {
					className: "green",
					cx: 29,
					cy: 41.83,
					r: 2
				}),
				/* @__PURE__ */ _jsx("circle", {
					className: "grey",
					cx: 35,
					cy: 41.83,
					r: 2
				})
			]
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Warning",
			children: [/* @__PURE__ */ _jsx("path", {
				className: "black",
				d: "M38.77,24.59h-13.54c-1.08,0-2.06-.56-2.6-1.5s-.54-2.06,0-3l6.77-11.71c.54-.94,1.51-1.5,2.6-1.5s2.05.56,2.6,1.5l6.77,11.71c.54.94.54,2.06,0,3s-1.51,1.5-2.6,1.5ZM32,8.88c-.17,0-.61.05-.87.5l-6.77,11.71c-.26.45-.09.85,0,1,.09.15.34.5.87.5h13.54c.52,0,.78-.35.87-.5.09-.15.26-.55,0-1l-6.77-11.71c-.26-.45-.69-.5-.87-.5Z"
			}), /* @__PURE__ */ _jsx("path", {
				className: "red",
				d: "M32.42,20.85c-.21-.2-.31-.47-.31-.79v-.67h-3.47c-.28,0-.5-.07-.65-.21-.16-.14-.23-.33-.23-.58,0-.19.05-.39.15-.6.1-.21.25-.46.46-.77l2.77-4.16c.16-.23.28-.4.37-.52.09-.11.21-.22.37-.31.16-.1.35-.14.58-.14.26,0,.47.07.62.2.15.13.22.31.22.53s-.09.46-.26.71l-2.92,4.37h1.99v-.97c0-.31.1-.57.31-.78s.47-.31.78-.31.57.1.78.31.31.47.31.78v.97h.37c.21,0,.38.07.53.21.14.14.22.32.22.53s-.07.38-.22.53-.32.22-.53.22h-.37v.67c0,.32-.1.58-.31.79-.21.2-.47.31-.78.31s-.57-.1-.78-.31Z"
			})]
		})]
	})]
});
export default SvgAppIcBefehl29;
